import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import logo from "../logo.png";
import queryString from "query-string";
import loadingIcon from "../Assets/loading.gif";
import firebase from '../firebase';
import { addArticleToUserPlaylist } from "../audiblogsApi";
import history from "../history";
import { Link } from "react-router-dom";
import gamificationStore from "../Stores/GamificationStore";

const Newsletter = observer((props) => {
  const [idToken, setIdToken] = useState("");
  const [isArticleSent, setIsArticleSent] = useState(false);

  useEffect(() => {
    console.log(props);
    let params = queryString.parse(props.location.search);
    const articleUrl = params.article_url;
    const articleTitle = params.article_title;
    // mixpanel.track("Open Discover");
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdToken()
          .then((res) => {
            setIdToken(res);
            addArticleToUserPlaylist(
              { id: articleUrl, title: articleTitle, type: "newsletter" },
              res,
              "/newsletter"
            ).then(() => {
              // Award bonus characters for adding first article
              gamificationStore.completeAction(gamificationStore.actions.ADD_ARTICLE);
            }).catch((err) => {
              console.error('Error adding newsletter article:', err);
            });

            // TODO: ideally, we use async/await to hear back a success
            // message from backend (addArticleToUserPlaylist)
            setTimeout(() => {
              setIsArticleSent(true);
            }, 1000);

            setTimeout(() => {
              history.push("/");
            }, 2500);
          });
      } else {
        history.push(
          `/signin?redirected_from=newsletter&article_url=${encodeURIComponent(
            articleUrl
          )}&articleTitle=${encodeURIComponent(articleTitle)}`
        );
      }
    });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <a href="https://audioread.com">
          <img
            src={logo}
            className="App-logo"
            alt="logo"
            style={{
              margin: "20px auto 0 auto",
              width: "auto",
              height: "10vh",
            }}
          />
        </a>

        <div>
          {!isArticleSent ? (
            <>
              <h1>Adding article to your feed...</h1>
              <div>
                <img
                  src={loadingIcon}
                  alt="Loading Icon"
                  width="50"
                  height="auto"
                />
              </div>
            </>
          ) : (
            <div>
              <h1>Added! Redirecting...</h1>
              <Link to="/">Click this if it doens't redirect</Link>
            </div>
          )}
        </div>
        {/* TODO: Add similar articles here? */}
      </div>
    </div>
  );
});

export default Newsletter;
